import moment from 'moment-timezone'
import { pipe, pluck, prop, filter, propEq, length} from 'ramda'

// const getSelected = filter(propEq('selected', true))
// const mask = (a, b) => a | b
// const reduceDayMask = pipe(
//   getSelected,
//   pluck('value'),
//   reduce(mask, 0)
// )
const workerStatuses = {
  'SUSPENDED': {class: 'warning', description: 'Suspended'},
  'ELIGIBLE': {class: 'success', description: 'Eligible'},
  'FIRED': {class: 'danger', description: 'Fired'},
  'FAILED_INTERVIEW': {class: 'danger', description: 'Failed Interview'},
  'FOLLOW_UP_INTERVIEW': {class: 'primary', description: 'Needs Interview'},
  'PASSED_INTERVIEW': {class: 'primary', description: 'Passed Interview'},
  'STARTED_SIGN_UP': {class: 'default', description: 'Signed Up'},
  'PENDING': {class: 'rose', description: 'Pending'},
  'ENTERED_GENERAL_INFO': {class: 'rose', description: 'Entered General Info'},
  'SIGNED_CONTRACT': {class: 'rose', description: 'Sign Contract'},
  'ENTERED_BACKGROUND_CHECK_INFO': {class: 'rose', description: 'Entered Background Check'},
  'RUNNING_BACKGROUND_CHECK': {class: 'passive', description: 'Running Checkr'},
  'ELIGIBLE_EOR': {class: 'passive', description: 'EOR'},
  'ENTERED_TAX_INFO': {class: 'passive', description: 'Entered Tax Info'},
  'NO_SHOW_INTERVIEW': {class: 'dark', description: 'No Show Interview'},
  'DOUBLE_PROFILE': {class: 'dark', description: 'Duplicate Account'},
  'PAUSED_PROFILE': {class: 'dark', description: 'Paused'},
  'FAILED_BACKGROUND_CHECK': {class: 'danger', description: 'Failed Background'}
}

const getSelected = filter(propEq('selected', true))
class AddWorkerController {
  /* @ngInject */
  constructor ($mdDialog, $stateParams, Users, job, shift, $mdToast, workforce, repost, Auth) {
    this.job = job
    this.$mdDialog = $mdDialog
    this.Auth = Auth
    this.$mdToast = $mdToast
    this.minStartDate = new Date()
    this.minEndDate = new Date()
    this.workerStatuses = workerStatuses
    if (shift) {
      this.shift = shift
      this.startDate = moment(shift.start || job.start_date).format()
      let shiftStartMinute = moment(job.start_date).get('minute')
      let shiftStartHour = moment(job.start_date).get('hour')
      let startTime = moment().add(1, 'days').set({'hour': shiftStartHour, 'minute': shiftStartMinute, 'second': 0}).format()
      this.startTime = new Date(startTime)
      this.endDate = moment().add(30, 'days').format()
      let shiftEndMinute = moment(job.end_date).get('minute')
      let shiftEndHour = moment(job.end_date).get('hour')
      let endTime = moment().set({'hour': shiftEndHour, 'minute': shiftEndMinute, 'second': 0}).format()
      this.endTime = new Date(endTime)
    }
    this.needed = 1
    this.title = job.title
    this.timezone = job.timezone
    this.showShiftDates = false
    // this.days = reduceDayMask(job.days)
    this.Users = Users
    this.workforce = filter(propEq('dont_sendor', null), (workforce))
    this.completedAddWorker = false
    this.addedWorkers = []
    this.repost = repost
  }

  validateDate () {
    this.errors = []
    let startDate = moment(this.startDate)
    let endDate = moment(this.endDate)
    if (startDate > endDate) {
      this.errors.push('End date is before start date')
      this.jobTimeForm.startDate.$error = {maxdate: true}
      this.jobTimeForm.$invalid = true
    }
  }

  addWorkerShifts (worker) {
    let userIds = [worker.external_id]
    // If Manage Jobs Page since it passes in a different job ID
    let jobId = this.job.id || this.job.job_id
    this.Users.checkOverlap({userIds, jobId})
      .then(null, this.handleOverlap.bind(this))
      .then(() => this.Users.putOnJob(userIds, jobId, this.job.shift !== 0 ? this.startDate : null))
      .then(() => {
        const msg = `Added ${worker.firstName} On Job!`
        this.$mdToast.showSimple(msg)
        this.addedWorkers.push(worker)
        worker.added = true
        this.workforce.forEach(x => { x.selected = false })
        return
      })
      .catch((err) => {
        if (!err) return
      })
  }

  handleOverlap (e) {
    if (!e.status || e.status !== 409) throw e
    let text
    let title

    const users = pipe(
      prop('reason'),
      JSON.parse,
      pluck('name')
    )(e.data)

    title = users + ' has a conflicting shift. Continue putting them on the job anyways?'

    const confirm = this.$mdDialog.confirm()
      .title(title)
      .multiple(true)
      .textContent(text)
      .ariaLabel('Conflict confirm')
      .ok('Yes')
      .cancel('No')

    return this.$mdDialog.show(confirm)
  }

  cancel () {
    this.$mdDialog.cancel()
  }

  doneAdding () {
    this.$mdDialog.hide(this.addedWorkers)
  }

  getSelectedWorkers () {
    return length(getSelected(this.workforce))
  }

  confirmWorkers () {
    this.addedWorkers = getSelected(this.workforce)
    this.completedAddWorker = true
  }

}

export default AddWorkerController
